export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    ;
    return false;
  }
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleString();
};

export const getStatusVariant = (status: string): string => {
  const variants: { [key: string]: string } = {
    'Success': 'success',
    'Failed': 'danger',
    'FAILED': 'danger',
    'Pending': 'warning',
    'Partial Success': 'info',
  };
  return variants[status] || 'secondary';
};

export const validateUrl = (url: string): boolean => {
  return /^https?:\/\/.+/.test(url);
};

export const validateJson = (jsonString: string): { valid: boolean; data?: any } => {
  try {
    const data = JSON.parse(jsonString);
    return { valid: true, data };
  } catch {
    return { valid: false };
  }
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};